var React = require('react');

function Rating (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.613 18.413 7.473 20.7a.8.8 0 0 1-1.177-.828l.802-4.987a.801.801 0 0 0-.215-.685l-3.457-3.57a.802.802 0 0 1 .452-1.348l4.711-.732a.8.8 0 0 0 .602-.45l2.084-4.44a.8.8 0 0 1 1.45 0l2.084 4.44a.8.8 0 0 0 .602.45l4.711.732a.801.801 0 0 1 .452 1.349l-3.457 3.57a.8.8 0 0 0-.215.684l.801 4.987a.8.8 0 0 1-1.177.828l-4.14-2.287a.8.8 0 0 0-.773 0Z","stroke":"#909090","strokeWidth":"2"}));
}

Rating.defaultProps = {"fill":"none","viewBox":"0 0 24 24","width":"288","height":"199"};

module.exports = Rating;

Rating.default = Rating;
